import { PlanBadge } from '../PlanBadge';

type Props = {
  isCurrentPlan?: boolean;
};

export const CurrentPlanBadge = ({ isCurrentPlan }: Props) =>
  isCurrentPlan ? (
    <PlanBadge label="Current plan" color="indigo" size="sm" />
  ) : null;
